import { createSelector } from 'reselect';
import FluxVolumeOperatorReportColumns from '../../containers/FluxVolumeOperatorReportColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { getAvg, getTotal } from '../../../../react-table/helpers/calculateTotal';
import FluxVolumeOperatorReportTotalColumns from '../../containers/FluxVolumeOperatorReportTotalColumns';

export const getIsLoading = (state) => state.listing.REPORTING_FLUX_VOLUME_OPERATOR.isLoading;
export const getData = TableDefinitions.REPORTING_FLUX_VOLUME_OPERATOR.getDataFunction();
export const getFilteredData = (state) => state.listing.REPORTING_FLUX_VOLUME_OPERATOR.filteredData;
export const getColumns = createSelector(getData, FluxVolumeOperatorReportColumns);
export const getTotalData = createSelector(
  getData,
  (data) => {
    if (!data.length) {
      return [];
    }
    return [
      { name: 'Total', ...getTotal(data) },
      { name: 'Avg', ...getAvg(data) },
    ];
  },
);
export const getTotalFilteredData = createSelector(
  (state) => state.listing.REPORTING_FLUX_VOLUME_OPERATOR.filteredData,
  (data) => [
    { name: 'Total', ...getTotal(data) },
    { name: 'Avg', ...getAvg(data) },
  ],
);
export const getTotalColumns = createSelector(getData, FluxVolumeOperatorReportTotalColumns);
